// extracted by mini-css-extract-plugin
export default {"iconSocial":"GroupSocialLink_iconSocial__npp05","listIcon":"GroupSocialLink_listIcon__BIf4t"};